import { render } from "./DocumentFieldLiveUri.vue?vue&type=template&id=150521b4"
import script from "./DocumentFieldLiveUri.vue?vue&type=script&lang=js"
export * from "./DocumentFieldLiveUri.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__